import type { CallCategory } from "@expert/shared-types";

export const callCategoryDisplayNames: Record<CallCategory, string> = {
    "APPLICATION/SOFTWARE_TROUBLESHOOTING": "App/Software",
    BATTERY: "Battery",
    BILLS_AND_PAYMENT: "Bills & Payment",
    CARRIER_ACCOUNT_MANAGEMENT: "Account Management",
    CONNECTIVITY_AND_NETWORK: "Connectivity",
    DEVICE_ACTIVATION: "Device Activation",
    DEVICE_HARDWARE_TROUBLESHOOTING: "Device Hardware",
    INSURANCE_AND_CLAIMS: "Insurance & Claims",
    MESSAGING: "Messaging",
    NOT_ENOUGH_INFORMATION: "Unclassified",
    PHONE_CALLS: "Phone Calls",
    SECURITY_AND_PRIVACY: "Security & Privacy",
    STORAGE_AND_CONTENT_MANAGEMENT: "Storage & Content",
    VOICEMAIL: "Voicemail",
    DEVICE_DAMAGE: "Device Damage",
    DEVICE_ORDER_STATUS: "Device Order Status",
    DEVICE_REPAIR: "Device Repair",
    DEVICE_REPLACEMENT: "Device Replacement",
    GENERAL_CUSTOMER_SUPPORT: "General Support",
    ORDER_STATUS: "Order Status",
    SIM_AND_PUK_ISSUES: "SIM & PUK",
    TECHNICAL_SUPPORT: "Tech Support",
    ACCOUNT_MANAGEMENT: "Account Management",
    ALTERNATE_LANGUAGE_REQUEST: "Language Request",
    FEATURES_AND_BENEFITS: "Features & Benefits",
    INSTALLATION_AND_SETUP: "Installation & Setup",
    SUBSCRIPTION_MANAGEMENT: "Subscription",
    UNINSTALL_AND_REMOVAL: "Uninstall & Removal",
    USAGE_AND_FUNCTIONALITY: "Usage & Functionality",
    VIRUSES_MALWARE_SPAM: "Viruses & Malware",
    VPN: "VPN",
};

export function getCallCategoryDisplayName(category: CallCategory): string {
    return callCategoryDisplayNames[category] ?? category;
}
